import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from "react";
import '../../../../cssfiles/homepage.css';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useSelector } from 'react-redux';

const rows_asset_status_table = [
    ['AHU', '1', 'JHS713L203', 'Connected', '2024-05-27 15:04:11'],
    ['Chiller', '2', 'JHS713L204', 'Connected', '2024-05-27 15:10:40'],
    ['ETS', '3', 'JHS713L205', 'Disconnected', '2024-05-21 13:26:57'],
    ['Plating Planet', '4', 'JHS713L206', 'Connected', '2024-05-28 08:09:37'],
    ['Compressor Panel', '5', 'JHS713L207', 'Connected', '2024-05-28 08:30:45'],
    ['M.Lighting Panel', '6', 'JHS713L208', 'Connected', '2024-05-28 10:25:19'],
    ['Press Shop', '7', 'JHS713L209', 'Disconnected', '2024-05-21 19:53:05'],
]

export default function DropdownTablewidget(props){
    //console.log("IN Tablewidget I AM IN");

    //{console.log("inside Tablewidget props.widgetprop.props.extended.",props.widgetprop.props.extended)}
    //{console.log("inside Tablewidget props.widgetprop.widgetname.",props.widgetprop.widgetname)}
    //{console.log("inside Tablewidget props.widgetprop.type.",props.widgetprop.type)}
    /*
    const rows = [
        createData('Baseline Target','9000.00' ),
        createData('Yearly Target', '8000.00'),
        createData('Yearly Consumption', '3200.00'),
        createData('This Months Target', '666.66'),
        createData('This Months Deviation', '0.00'),
        createData('Months Asking Rate', '533.00'),
        createData('Todays Consumption', '16.66'),
    ];
    function createData(  name,  value,  ) {
        return { name, value, };
    }
    */
    const filter = useSelector((state) => state.mainpagedata.filter)
    //const [assetStatusTableRows, setAssetStatusTableRows] = useState(rows_asset_status_table)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
    console.log("Tablewidget insi**********************tagcollectionvalue********************",tagcollectionvalue)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    
    var dataobject = {};
    
    
    


    /*
    tagproperties.map((tagprops)=>{
        var key = tagprops.id;
        var data = {};
        console.log("dataobject---",dataobject)
        tagproperties.map((nestedtagprops)=>{      
            if(key == nestedtagprops.id)
            { 
                var nestedkey = nestedtagprops.column_category;
                var nestedvalue = tagcollectionvalue[nestedtagprops.tagname];
                var totalnestedvalue = 0.0;
                if(Array.isArray(nestedvalue)){
                    totalnestedvalue = nestedvalue.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue.y), 0.0)
                }else{
                    totalnestedvalue=nestedvalue
                }

                if(!data.hasOwnProperty(nestedkey)){
                    data[nestedkey] = totalnestedvalue;
                }
            }    
        })
        dataobject[key]=data;
    })
    console.log("complete dataobject",dataobject)

    for(let key in dataobject){
        var valuearray=[];
        for(let i=0;i<head_values.length;i++){
            valuearray.push(dataobject[key][head_values[i]]) 
        }
        rows_values.push(valuearray);
    } 
    */



    //Energy Profile
    const head_energy_profile = ['',''];
    const rows_energy_profile =[['Baseline Target','9000.00'], ['Yearly Target', '8000.00'],['Yearly Consumption', '3200.00'],['This Months Target', '666.66'],['This Months Deviation', '0.00'],['Months Asking Rate', '533.00'],['Todays Consumption', '16.66']] 

    const head_scopewise_emissions = ['S. No.','Metric','Scope','Quantity','CO2(tonnes)','CH4(tonnes)','N2O(tonnes)','tCO2e'];
    const rows_scopewise_emissions =[['1','Fuel Consumption','1','5,000 liter/day','35','0.035','0.0035','35.5'], ['2','Fuel Consumption','1','5,000 liter/day','35','0.035','0.0035','35.5'],['3','Fuel Consumption','1','5,000 liter/day','35','0.035','0.0035','35.5']] 

    const head_tod_values = ['TOD Zones','Time of Day','Units(kWh)','Unit Rate','Total Cost(INR)'];
    const rows_tod_values =[['Zone 1','09:00-12:00','80.00','13.00','1040.00'],['Zone 2','12:00-15:00\n18:00-22:00','120.00','11.50','1380.00'],['Zone 3','22:00-06:00','140.00','10.50','1470.00'],['Zone 4','06:00-09:00\n15:00-18:00','70.00','12.50','875.00']] 

    const head_energy_budget  = ['Department','Consumed','Targeted','Status'];
    const rows_energy_budget =[['Department1','120.00','150.00','ON TARGET'],
    ['Department2','130.00','120.00','DEVIATED BY 3%'],
    ['Department3','160.00','150.00','DEVIATED BY 3%'],
    ['Department4','90.00','100.00','ON TARGET'],
    ['Department5','130.00','120.00','DEVIATED BY 3%'],
    ['Department6','120.00','150.00','ON TARGET'],
    ['Department7','80.00','100.00','ON TARGET'],
    ['Department8','90.00','100.00','ON TARGET'],
    ];

    const head_energy_cost  = ['Department','Expense','Targeted','Status'];
    const rows_energy_cost =[['Department1','100.00','120.00','ON TARGET'],
    ['Department2','120.00','130.00','DEVIATED BY 3%'],
    ['Department3','150.00','140.00','DEVIATED BY 3%'],
    ['Department4','80.00','100.00','ON TARGET'],
    ['Department5','160.00','150.00','DEVIATED BY 3%'],
    ['Department6','140.00','150.00','ON TARGET'],
    ['Department7','80.00','120.00','ON TARGET'],
    ['Department8','100.00','130.00','ON TARGET'],

    ];

    const head_community_engagement  = ['',''];
    const rows_community_engagement =[['Number of Beneficiaries','12'],['Amount Spent on Community Welfare Activities','Rs. 25000/-']];

    const head_minmax  = ['',''];
    const rows_minmax =[['Minimum Voltage','212.22'],['Maximum Voltage','412.22']];

    const head_upcoming_maintenance = ['Asset Name','Due Date','Last Maintenance Date'];
    const rows_upcoming_maintenance =[['Asset 1','05-06-2023','05-06-2024'],['Asset 2','15-06-2023','15-06-2024'],['Asset 3','25-06-2023','25-06-2024'],['Asset 4','05-07-2023','05-07-2024'],['Asset 5','15-07-2023','15-07-2024'],['Asset 6','25-07-2023','25-07-2024'],['Asset 7','30-07-2023','30-07-2024']];
    
    const head_gateway_status_table = ['Gateway Name', 'Gateway Serial Number']
    const rows_gateway_status_table = [
        ['IG502-1', 'CAN544B806'],
        ['IG502-2', 'CAN544B807'],
        ['IG502-3', 'CAN544B808'],
        ['IG502-4', 'CAN544B809'],
    ]

    const head_asset_status_table = ['Asset Name', 'Asset ID', 'Asset Serial Number', 'Connection State', 'Last Active Time']
    /*const rows_asset_status_table = [
        ['AHU', '1', 'JHS713L203', 'Connected', '2024-05-27 15:04:11'],
        ['Chiller', '2', 'JHS713L204', 'Connected', '2024-05-27 15:10:40'],
        ['ETS', '3', 'JHS713L205', 'Not Connected', '2024-05-21 13:26:57'],
        ['Plating Planet', '4', 'JHS713L206', 'Connected', '2024-05-28 08:09:37'],
        ['Compressor Panel', '5', 'JHS713L207', 'Connected', '2024-05-28 08:30:45'],
        ['M.Lighting Panel', '6', 'JHS713L208', 'Connected', '2024-05-28 10:25:19'],
        ['Press Shop', '7', 'JHS713L209', 'Not Connected', '2024-05-21 19:53:05'],
    ]*/
    
    
    
    //Generic variables
    const [table_head, setTableHead] = useState([]);
    const [table_rows, setTableRows] = useState([]);

    useEffect(() => { 
        //console.log("table name ",props.widgetprop.widgetname)
        var head_values = props.widgetprop.props.extended.column_categories;
        var tagproperties = props.widgetprop.props.extended.tagprops;
        var rows_values = [];

        tagproperties.map((tagprops)=>{
            //console.log("props.selectedValue",props.selectedValue)
            //console.log("tagprops.optionname",tagprops.optionname)
            if(props.selectedValue == tagprops.optionname){
                var rowname = tagprops.tagname;
                var singlerowdata = [];
                
                for(let keyname in tagprops.calculation.calculation_operations_list){
                    var currrowvalue = tagprops.calculation.calculation_operations_list[keyname].operand_1;
                    var accessrowvalue = rowname +"."+currrowvalue;
                    console.log("tagcollectionvalue[accessrowvalue]---------",tagcollectionvalue[accessrowvalue])
                    if(typeof tagcollectionvalue[accessrowvalue]=="number"){
                        singlerowdata.push(Number(tagcollectionvalue[accessrowvalue]).toFixed(2))
                    }else{
                        singlerowdata.push(tagcollectionvalue[accessrowvalue])
                    }
                    
                }
                rows_values.push(singlerowdata)
            }
            
        })
        console.log("rows_values in table widgte",rows_values)

        switch(props.widgetprop.widgetname)
        {
            case 'Emissions Inventory':
                setTableHead(head_values)
                setTableRows(rows_values)
                break
            case 'Status Table':
                console.log("head_values in status table",head_values)
                console.log("rows_values in status table",rows_values)
                setTableHead(head_values)
                setTableRows(rows_values)   
                break
            case 'Losses (kWh)':
                //console.log("head_tod_values",head_tod_values)
                //console.log("rows_tod_values",rows_tod_values)
                setTableHead(head_values)
                setTableRows(rows_values)
                break
            case 'Community Engagement':
                setTableHead(head_community_engagement)
                setTableRows(rows_community_engagement)
                break
            case 'Minimum & Maximum Voltage (V)':
                setTableHead(head_minmax)
                setTableRows(rows_minmax)
                break
            case 'Upcoming Maintenance':
                setTableHead(head_upcoming_maintenance)
                setTableRows(rows_upcoming_maintenance)
                break
            case 'Gateway List':
                setTableHead(head_gateway_status_table);
                setTableRows(rows_gateway_status_table);
                break
            case 'Asset List':
                setTableHead(head_asset_status_table);
                setTableRows(rows_asset_status_table);
                break
            default:
                setTableHead([]);
                setTableRows([]);
                break
        }}, [props.widgetprop.widgetname, props.selectedValue, tagcollectionvalue]);
        
        useEffect(() => {
            if(props.widgetprop.widgetname === 'Asset List') {
                //console.log("filter ",filter)
                if (filter === 'All') {
                    setTableRows(rows_asset_status_table)
        
                } else if (filter === 'None') {
                    setTableRows([])
                }
                else {
                    setTableRows(rows_asset_status_table.filter(d => d[3] !== filter))
                }
            }
        }, [filter])
        // function Rows({ row_value }) {
        //     const value = row.split("\n");
          
        // }

        function BreakLine({ value }) {
            const breaklines = value.split("\n");
          
            return (
              <List sx={{padding:'4px 0px 4px 0px'}}>
                {breaklines.map((line, i) => (
                  <ListItem sx={{padding:'2px 0px 2px 0px'}} key={i}>{line}</ListItem>
                ))}
              </List>
            );
          }

          return(
            <>
            {(table_rows.length > 0 ) && ( 
                
                <TableContainer component={Paper} sx={{ width: '100%', height:"100%",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px' }} elevation={0}>
                <Table sx={{ width: '100%' }} size="small">
                    {
                           <TableHead>
                                    <TableRow sx={{border:"0px"}}>
                                    {table_head.map((table_head_value) => 
                                    (
                                       
                                        <TableCell sx={{
                                                        fontSize:props.widgetprop.props.extended.tablehead.fontsize,
                                                        fontWeight:props.widgetprop.props.extended.tablehead.fontweight,color:"var(--grey-variation-tableLK)"
                                                      }}>{table_head_value}
                                                      </TableCell>
                                    ))}
                                    </TableRow>
                                </TableHead>
                            
                        
                    }
                     {console.log("/////////////////////////////table_head///////////////////////",table_head)}
                     {console.log("/////////////////////////////table_rows///////////////////////",table_rows)}
                    {console.log("table_rows here",table_rows)}
                    <TableBody>
                        {table_rows.map((row,index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}
                            >   
                                {row.map((row_value, row_index)=>(
                                                                                    
                                                    <TableCell component="th" scope="row" sx={{fontSize:props.widgetprop.props.extended.tablerows.fontsize,
                                                        fontWeight:props.widgetprop.props.extended.tablerows.fontweight,color: (row_value === 'Connected' || row_value === 'ON TARGET') ? '#00943D' : (row_value === 'Disconnected' || row_value === 'DEVIATED BY 3%') ? '#DC272D' : 'var(--grey-variation-tablerowsLK)'}} >
                                                                {/*(row_value.includes('\n'))?<BreakLine value={row_value}/>:row_value*/}
                                                                {row_value}                                                
                                                    </TableCell>
                                        
                                        
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>)}
            </>
        )
    
}


/*
{(row_index==1 && props.widgetprop.widgetname=='TOD')?<BreakLine value={row_value}/>:row_value}


                                                        {row_value.includes('\n')?<BreakLine value={row_value}/>:row_value}

*/ 